import { Routes, RouterModule, Router } from '@angular/router';

import { InicioComponent } from './componentes/shared/inicio/inicio.component';
import { PaginaComponent } from './componentes/shared/pagina/pagina.component';
import { AppComponent } from './app.component';

const RUTAS: Routes = [
    { path: 'inicio', component: InicioComponent },
    { path: 'mrkt/:param', component: PaginaComponent },
    { path: 'mrkt', component: PaginaComponent },
    { path: 'auth', component: AppComponent },
    { path: '**', pathMatch:'full', redirectTo:'auth'},

    //{ path: 'path/:routeParam', component: MyComponent },
    //{ path: 'staticPath', component: ... },
    //{ path: '**', component: ... },
    //{ path: 'oldPath', redirectTo: '/staticPath' },
    //{ path: ..., component: ..., data: { message: 'Custom' }
];
export const APP_ROUTING = RouterModule.forRoot(RUTAS,{ useHash: true, relativeLinkResolution: 'legacy' });
